import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  checked_items: [],
  collections_list: [],
  collections: [],
  collection_id: {},
};

const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {
    checkedCollectionItems(state, action) {
      state.checked_items = action.payload;
    },
  },
});

export const { checkedCollectionItems, filterCollectionsList } =
  collectionsSlice.actions;
export default collectionsSlice.reducer;
